<template>
  <div class="LibraryRequestComponent">
    <p>{{ lang.infotext_1 }}</p>
    
    <b-form >

           
      <b-form-group id="input-group-Remarks" :label="lang.label_Remarks" >
      <b-form-textarea id="comment-Remarks" class="item-form remarks-textarea mb-1" rows="6" v-model="form.remarks" size="sm" placeholder="Enter something..."></b-form-textarea>
      </b-form-group>
      <b-form-group id="input-group-Priority" :label="lang.label_Priority" label-for="input-Priority">
        <b-form-select v-model="form.priority" :options="priority" size="sm"></b-form-select>
        <!-- <b-form-invalid-feedback id="input-Priority-feedback" :state="validation_Priority">
            {{lang.validinfo_Priority}}
        </b-form-invalid-feedback> -->
      </b-form-group>
      <b-form-group id="input-group-Deadline" :label="lang.label_Deadline" label-for="input-Deadline">
        <!-- <b-form-datepicker id="endoflife-datepicker" v-model="form.deadline" :state="validation_deadline" size="sm" class="mb-1 datepicker-deadline"></b-form-datepicker> -->
        <!-- <b-form-input
          id="input-deadline"
          v-model="form.deadLine"
          size="sm"
          type="date"   
          
        ></b-form-input> -->
        <b-form-datepicker 
          id="input-deadline" 
          v-model="form.deadLine"
          size="sm" 
          class="datepicker-deadline mb-3"
        ></b-form-datepicker>
        <b-form-invalid-feedback id="input-deadline-feedback" :state="validation_deadline">
          {{lang.validinfo_Deadline}}
        </b-form-invalid-feedback>
        <br>
        <b-form-group id="input-group-Files" :label="lang.label_Files" label-for="input-Files">
          <b-form-file id="file-import" 
            v-model="form.file" 
            :placeholder="lang.placeholder_Files"
            :drop-placeholder="lang.placeholder_Files" class="import-file" 
            size="sm"
            multiple
          ></b-form-file><br>
          <!-- <label v-show="!extension" class="file-import-invalid">
            {{ lang.validinfo_Files }}
          </label> -->

        </b-form-group>

        <b-button class="btn create-button" size="sm" @click="createLibRequest" :variant="variant">
            {{lang.button_CreateLibRequest}}</b-button>
        <!-- <b-form-invalid-feedback id="input-footprint-feedback">
          {{lang.validinfo_1}}
        </b-form-invalid-feedback> -->
      </b-form-group>


      
    </b-form>
    <br>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import * as Tools from '@/Tools/Tools';

export default {
  name: 'LibraryRequestComponent',
  props:{
    lang: Object,
    source: String
  },
  components: {


  },
  data () {
    return {
      form: {

        manufacturer: "",
        manufacturerPartNumber: "",
        remarks: "",
        deadLine: "",
        priority: "Normal",
        type: "",
        file: [],
        
      },
      priority: [
    
        { value: 'Normal', text: 'Normal' },
        { value: 'High', text: 'High' },
        { value: 'Low', text: 'Low' },
      ],
      fileFeedback: [],
    }
  },
  computed: {
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    textColors() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return ['tabs-bg-dark', 'tabs-text-light']
      } else {
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    validation_deadline() {

      const deadline = new Date(this.form.deadLine);
      const now = new Date();

      
      if (deadline >= now) {
       
        return true;
      } else if (deadline < now) {
        
        return false;
      } 

    },
    requestId() {
      if (this.$route.query.requestId != undefined && this.$route.query.requestId != null && this.$route.query.requestId != "") {
        return this.$route.query.requestId;
      }
      return null;
    }
  },
  created () {
    this.$store.commit("REQUESTCREATEFORM", this.form);

  },
  watch: {
    value: function (newVal, oldVal) {


    }
  },
  updated() {
    this.$store.commit("REQUESTCREATEFORM", this.form);


  },
  mounted: function () {

  },

  methods: {
    importFile(requestId){

      this.$store.dispatch("showLoader", {visible: true, text: "push"});
      
      let vue = this;
      
      let lei = vue.form.file.length;
      


      const obj = {
        requestId: requestId,
        file: vue.form.file[vue.fileCounter],
        lastModified: Tools.IntegerToIntegerUTC(vue.form.file[vue.fileCounter].lastModified)
        
      }
      
      let fileName = vue.form.file[vue.fileCounter].name;
      
      vue.$store.dispatch("rm_importRequestFile", obj)
      .then(function(result){
        console.log(result);
        let obj2 = {};
        if (result.status == "OK"){
          
          obj2 = {
            result: "Added",
            fileName: fileName,            
            
          }
          
        }else{
          
          
          obj2 = {
            result: result.message,
            fileName: fileName,            
            
          }
          
          
        }
        vue.fileFeedback.push(obj2);
        
        
        vue.fileCounter++;
        
          if (vue.fileCounter > lei - 1){
            
            vue.$store.dispatch("showLoader", { visible: false, text: "" }); 

            

            const reloadObj = {
              status: true,
              name: "RequestDetailsComponent",
              source: ""
            }
            vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            if (vue.fileFeedback.length > 0) {

              let func = function () {
                vue.fileFeedback = [];
                //vue.toDetails(requestId);

                
              }

              
              const dataFiles = {
                fileImportResults: {},
                newRevisionId: null
              }
              for (let i = 0, lei = vue.fileFeedback.length; i < lei; i++){

                const obj = {
                  result: vue.fileFeedback[i].result,
                            
                  
                }
                
                dataFiles.fileImportResults[vue.fileFeedback[i].fileName] = obj;
              }
              
              vue.$store.dispatch("showLoader", {visible: false, text:""});
              vue.fileFeedback = [];

              //think how to solve this problem
              // const obj = {
              //   title: vue.lang.modal_title_PushLibrary,
              //   text: "",
              //   type: "push_files",
              //   buttons: 1,
              //   buttonName: "Close",
              //   // buttonWait: buttonWait,
              //   // commentWait: commentWait,
              //   size: "xl",
              //   lang: vue.lang.modal_PushRequest,
              //   funcNo: "",
              //   funcYes: "",
              //   funcCustom: func,
              //   data: dataFiles
              // };
              
              // vue.$store.dispatch("showModalComponent", obj);
            }

            
            
          }else{
            
            vue.importFile(requestId);
          }

      })
    },
    createLibRequest() {
      let vue = this;

      let requestId = null;
      let partId = null;

      if (this.$route.query.requestId != null && this.$route.query.requestId != undefined && this.$route.query.requestId != "") {
        requestId = this.$route.query.requestId;
      } 

      if (this.$route.query.id != null && this.$route.query.id != undefined && this.$route.query.id != "") {
        partId = this.$route.query.id;
      } 

      const obj = {
        requestId: requestId,
        partId: partId,
        remarks: this.form.remarks,
        deadLine: this.form.deadLine,
        priority: this.form.priority,
        type: "library",
        libraryType: this.source

      }
      
      vue.$store.dispatch("rm_createLibRequest", obj)
        .then((result) => {

          console.log(result)

            if (result.status == "OK") {



              if (result.data != null) {

                let requestId = result.data.requestId;

                

                let obj = {
                  text: vue.lang.alert_success_CreateLibRequest,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);


                const objModal = {
                  ok: false,
                  cancel: false
                }

                vue.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)

                const modalAlert = {
                  text: vue.lang.alert_success_CreateLibRequest,
                  time: 10,
                  type: "success"
                }
                vue.$store.commit("SETMODALALERT", modalAlert);

                const objProperty = {
                  name: "Request#" + result.data.requestNumber,

                }

                let mutation = null;
                if (vue.source == "footprint") {
                  mutation = "ADDSELECTEDFOOTPRINTS";
                }
                if (vue.source == "symbol" || vue.source == "hdl symbol") {
                  mutation = "ADDSELECTEDSYMBOLS";
                }
                vue.$store.commit(mutation, objProperty)
              
                if (vue.form.file.length > 0) {


                  vue.fileCounter = 0;

                  vue.importFile(requestId);

                }
                

              } else {
                let obj = {
                  text: vue.lang.alert_error_CreateLibRequest + ". ",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

                const modalAlert = {
                  text: vue.lang.alert_error_CreateLibRequest + ". ",
                  time: 15,
                  type: "danger"
                }
                vue.$store.commit("SETMODALALERT", modalAlert);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_CreateLibRequest + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);

              const modalAlert = {
                text: vue.lang.alert_error_CreateLibRequest + ": " + result.message,
                time: 15,
                type: "danger"
              }
              vue.$store.commit("SETMODALALERT", modalAlert);
            }
        })

    }


  }
}
</script>


<style lang="scss">
  @import "./../../scss/modal";
  .LibraryRequestComponent{
    .remarks-textarea{
      height: 120px;
    }
    .datepicker-deadline{
      height: 32px;
    }
    .create-button{
      margin: 10px;
      margin-top: 25px;
    }
    .import-file{
      width: 100% !important;
      margin-left: 0px !important;
    }
  
  }
  
</style>


// WEBPACK FOOTER //
// src/components/shared/LibraryRequestComponent.vue